import { FaRegFrown, FaRegSmile } from "react-icons/fa";
import React from "react";
import { IoMdClose } from "react-icons/io";

const CardOpen = ({ title, dimension, type, longDescription, closeCard }) => {
  return (
    <div
      className={`fixed top-0 left-0 w-screen h-screen flex flex-col items-center justify-center text-center z-50`}
    >
      <div className="flex flex-col justify-center items-center w-screen h-screen">
        <div
          className="w-screen h-screen bg-white/10 backdrop-blur absolute top-0 left-0"
          onClick={closeCard}
        ></div>
        <div className="bg-white p-8 rounded-lg shadow-lg w-11/12 lg:w-8/12 max-h-[80%]  pb-12 relative overflow-y-auto">
          <div className='absolute top-4 right-4 cursor-pointer z-10'>
            <IoMdClose
                className="text-3xl text-gray-400 hover:text-gray-700 ease-in-out duration-150"
                onClick={closeCard}
            />
          </div>
          <div className="absolute top-6 left-6">
            <div
              className={`w-[60px] h-[60px] p-4 rounded-full flex justify-center items-center shadow-md ${
                type === "Atencao" ? "bg-yellow-600" : "bg-emerald-700"
              }`}
            >
              {type === "Atencao" ? (
                <FaRegFrown className="text-4xl text-white" />
              ) : (
                <FaRegSmile className="text-4xl text-white" />
              )}
            </div>
          </div>
          <div>
            {type === "Atencao" ? (
                <p className="relative text-2xl text-yellow-600 uppercase font-medium after:absolute after:bottom-[-8px] after:left-1/2 after:-translate-x-1/2 after:w-1/3 after:h-[0.2rem] after:bg-yellow-600 after:content-[''] mt-16 sm:mt-1.5">
                  Grupo de Atenção
                </p>
            ) : (
                <p className="relative text-2xl text-green-700 uppercase font-medium after:absolute after:bottom-[-8px] after:left-1/2 after:-translate-x-1/2 after:w-1/3 after:h-[0.2rem] after:bg-green-700 after:content-[''] mt-16 sm:mt-1.5">
                  Saúde em dia
                </p>
            )}

            <p className="pt-8 text-lg text-gray-800">
              {" "}
              <span className="font-bold">{dimension} </span> - {title}
            </p>
          </div>
          {type !== "Atencao" && (
            <div className="pt-6 text-sm text-left space-y-3 text-gray-800">
              <div>
                <p className="font-bold">
                  Parabéns! Você está fora do grupo de atenção.
                </p>
                <p>
                  Para conscientização, segue abaixo informações sobre o que
                  pode levar alguém a estar no grupo de atenção e/ou o
                  consequencias de estar no grupo de atenção.
                </p>
              </div>
            </div>
          )}

          <div className="pt-6 text-sm space-y-3 text-justify text-gray-800">
            {longDescription &&
              longDescription.map((item, index) => (
                <div key={index}>
                  {item.map((subItem, subIndex) => (
                    <p
                      className={`${subIndex === 0 ? "font-bold" : ""}`}
                      key={subIndex}
                    >
                      {subItem}
                    </p>
                  ))}
                </div>
              ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardOpen;
